import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ILocationState }       from 'Redux/Slices/Location/LocationSlice';
import { Location }             from 'Domain/Models';
import { PayloadActionList }    from 'Utils';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findLocationsRequest = (state: Draft<ILocationState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findLocationsSuccess = (state: Draft<ILocationState>, { type, payload }: PayloadAction<{
  locations: Record<string, Location>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.locations;
  state.maxCount = payload.maxCount || state.maxCount;

};

export const findLocationsFailure = (state: Draft<ILocationState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
